module.exports = __webpack_public_path__ + "img/back.ba543441.svg";